// custom js


function replaceH1WithSpan(id) {
  const h1 = document.getElementById(id);
  if (h1 && h1.tagName.toLowerCase() === 'h1') {
    const span = document.createElement("span");
    span.className = h1.className;
    span.id = h1.id;
    span.innerHTML = h1.innerHTML;
    h1.parentNode.replaceChild(span, h1);
  }
}

const targetIds = [
  "ship-dashed-headline",
  "cnvt-coupon-head",
  "ship-no-reward-headline"
];


const observer = new MutationObserver(() => {
  targetIds.forEach(replaceH1WithSpan);
});


observer.observe(document.body, { childList: true, subtree: true });


document.addEventListener("DOMContentLoaded", () => {
  targetIds.forEach(replaceH1WithSpan);
});




